import { exactAdd } from '@/utils/functions'
import { customerDic, userById, userPassword, customerById, accBalance, putTabsForUser, chargeTypesForUser } from '@/utils/customerApi'

export default {
  namespaced: true,
  state: {
    COMPANY_TYPE: [], // 企业验证类型
    userInfo: {}, // 注册用户信息
    customerInfo: { // 客户信息
      pointRemainingNum: 0 // 限免点位余量
    },
    balanceInfo: { // 账户信息
      balance: 0, // 总余额
      normalBalance: 0, // 普通账户总余额
      cash: 0, // 现金账户余额
      give: 0, // 赠款账户余额
      commision: 0 // 佣金账户余额
    },
    codeInfo: {
      cashCode: 0,
      grantCode: 0,
    },
    putOrderTabs: [], // 当前登录用户点位投放可用的tab选项
    userChargeTypes: [] // 当前登录用户点位投放可用的收费方式
  },
  getters: {
    allFee: state => state.balanceInfo.balance, // 当前账户总余额
    normalFee: state => state.balanceInfo.normalBalance, // 普通账户总余额
    vipFreeRemain: state => state.customerInfo.pointRemainingNum || 0, // 会员限免点位额度剩余量
    hasPayPwd: state => Boolean(state.userInfo.payPassword), // 是否已设置账户支付密码
    inviteCode: state => state.customerInfo.inviteCode, // 客户自身的推荐码（邀请他人用的标识符）
  },
  mutations: {
    setCusDic (state, {dicCode, dicData}) {
      state[dicCode] = dicData
    },
    setUserInfo (state, d) {
      state.userInfo = d
    },
    setCusInfo (state, d) {
      state.customerInfo = d
    },
    setBalance (state, d) {
      state.balanceInfo = d
    },
    setCodeInfo (state, d) {
      state.codeInfo = d
    },
    setPutTabs(state, tabs) {
      state.putOrderTabs = tabs
    },
    setChargeTypes(state, arr) {
      state.userChargeTypes = arr
    }
  },
  actions: {
    async getCusDic ({ commit, state }, dicCode) {
      if (state[dicCode] && state[dicCode].length) return
      const res = await customerDic(dicCode)
      if (res && res.code === 0) {
        const dicData = (res.data || []).map(d => {
          return {
            ...d,
            label: d.name,
            value: d.code
          }
        })
        commit('setCusDic', { dicCode, dicData })
      }
    },
    async getUserInfo ({ commit, dispatch, state }, uid) {
      const sid = state.userInfo ? state.userInfo.id : undefined
      const userId = uid || sid
      if (!userId) {
        console.log('%c 获取用户-用户ID不存在', 'background:#999;color:#FFFF00;padding:2px 6px 2px 0')
        return
      }
      let pwd = {}
      const pr = await userPassword(userId)
      if (pr && pr.code === 0) pwd = pr.data
      else console.warn('获取用户密码失败', pr)
      const res = await userById(userId)
      if (res && res.code === 0 && res.data) {
        const info = res.data
        info.password = pwd.password
        info.payPassword = pwd.payPassword
        commit('setUserInfo', info)
      }
      if (!state.putOrderTabs.length) {
        dispatch('getPutOrderTabs')
        dispatch('getUserChargeTypes')
      }
    },
    async getCustomerInfo ({ commit, state }, cusId) {
      const scid = state.userInfo ? state.userInfo.customerId : undefined
      const customerId = cusId || scid
      const res = await customerById(customerId)
      if (res && res.code === 0 && res.data) commit('setCusInfo', res.data)
    },
    async getAccBalance ({ commit, state }, uid) {
      const sid = state.userInfo ? state.userInfo.id : undefined
      const userId = uid || sid
      if (!userId) {
        console.log('%c 获取账户-用户ID不存在', 'background:#999;color:#FFFF00;padding:2px 6px 2px 0')
        return
      }
      const res = await accBalance(userId)
      if (res && res.code === 0 && res.data) {
        let total = 0,
          cash = 0,
          give = 0,
          normalBalance = 0,
          commision = 0
        // 根据accountType区分普通现金账户(1)/普通赠款账户(2)/佣金账户(3)/合同现金账户(4)/合同赠款账户(5)
        res.data.forEach(({ accountType: at, balance = 0 }) => {
          if (at === 1) {
            cash += balance / 1e3
            normalBalance += balance / 1e3
          }
          if (at === 2) {
            give += balance / 1e3
            normalBalance += balance / 1e3
          }
          if (at === 4) cash += balance / 1e3
          if (at == 5) give += balance / 1e3
          if (at === 3) commision = balance / 1e3
        })
        total = exactAdd(cash, give)
        total = exactAdd(total, commision)
        commit('setBalance', { balance: total, normalBalance, cash, give, commision })
        // 存储各类现金类型的code值
        let cashCode, grantCode, contractCashCode, contractGrantCode
        res.data.forEach((item) => {
          if (item.accountType === 1) cashCode = item.id
          if (item.accountType === 2) grantCode = item.id
          if (item.accountType === 4) contractCashCode = item.id
          if (item.accountType === 5) contractGrantCode = item.id
        })
        commit('setCodeInfo', { cashCode, grantCode, contractCashCode, contractGrantCode })
        return res.data
      }
    },
    async getPutOrderTabs({ commit, state }) {
      if (!state.userInfo.id) {
        return
      }
      const res = await putTabsForUser(state.userInfo.id)
      if (res && res.code === 0) {
        commit('setPutTabs', res.data || [])
      }
    },
    async getUserChargeTypes({ commit, state }) {
      if (!state.userInfo.id) {
        return
      }
      const res = await chargeTypesForUser(state.userInfo.id)
      if (res && res.code === 0) {
        commit('setChargeTypes', res.data || [])
      }
    }
  }
}
